export enum ErrorEnum {
  ASSIGNMENT_DELETED = 'ASSIGNMENT_DELETED',
}
